// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconRemoteClients = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 24 24' ref={ref} {...props}>
        <g clipPath='url(#icon-remote-clients_svg__a)'>
            <path
                fill='currentcolor'
                d='M0 15.214C0 18.408 2.419 21 5.4 21h13.8c2.651 0 4.8-2.302 4.8-5.143 0-2.487-1.65-4.564-3.84-5.038.154-.43.24-.9.24-1.39 0-2.13-1.612-3.858-3.6-3.858-.739 0-1.429.242-1.999.651C13.762 4.294 11.824 3 9.6 3c-3.315 0-6 2.877-6 6.429q.001.163.007.325C1.507 10.546 0 12.691 0 15.214'
            />
        </g>
        <defs>
            <clipPath id='icon-remote-clients_svg__a'>
                <path fill='currentcolor' d='M0 0h24v24H0z' />
            </clipPath>
        </defs>
    </svg>
)
const ForwardRef = forwardRef(SvgIconRemoteClients)
const Memo = memo(ForwardRef)
export default Memo
